export enum FeatureName {
  FastAccess = 'FastAccess',
  FastAccessRestrictions = 'FastAccessRestrictions',
  FastAccessAlerts = 'FastAccessAlerts',
  SmsNotifications = 'SmsNotifications',
  SmsMassAlerts = 'SmsMassAlerts',
  CA4K = 'CA4K',
  CA3000 = 'CA3000',
  EIQIntelliTicket = 'EIQIntelliTicket',
  Insight = 'Insight',
  Connect = 'Connect',
  CA3000CardClasses = 'CA3000CardClasses',
  CA3000Expirations = 'CA3000Expirations',
  NorthStar = 'NorthStar',
  ConnectEditPin = 'ConnectEditPin',
  CA3KLogsImport = 'CA3KLogsImport',
  CreateResidentAnonymously = 'CreateResidentAnonymously',
  MassAlerts = 'MassAlerts',
  IncidentReporter = 'IncidentReporter',
  LPR = 'LPR',
  EIQWhoIs = 'EIQWhoIs',
  GuestLimitations = 'GuestLimitations',
  BasIP = 'BasIP',
  GuestLimitationsForAdmins = 'GuestLimitationsForAdmins',
  DriveId = 'DriveId',
  FastAccessPrintDirection = 'FastAccessPrintDirection',
  SmartPlateId = 'SmartPlateId',
  Jonas = 'Jonas',
  GateController = 'GateController',
  EIQLive = 'EIQLive',
  DailyActivityReports = 'DailyActivityReports',
  EIQProfile = 'EIQProfile',
  PayEase = 'PayEase',
  EIQIntelliTicketEscalationTiers = 'EIQIntelliTicketEscalationTiers',
  ConnectFID = 'ConnectFID',
}

export const featureNameMap: Record<FeatureName, string> = {
  [FeatureName.FastAccess]: 'EIQ-Passport',
  [FeatureName.FastAccessRestrictions]: 'EIQ-Passport Restrictions',
  [FeatureName.FastAccessAlerts]: 'EIQ-Passport Alerts',
  [FeatureName.FastAccessPrintDirection]: 'EIQ-Passport on Directions document',
  [FeatureName.SmsNotifications]: 'SMS Notifications',
  [FeatureName.SmsMassAlerts]: 'SMS for the EIQ-Alert',
  [FeatureName.CA4K]: 'CA4K',
  [FeatureName.CA3000]: 'CA3000',
  [FeatureName.EIQIntelliTicket]: 'EIQ-IntelliTicket',
  [FeatureName.Insight]: 'EIQ-Insight',
  [FeatureName.Connect]: 'EIQ-Connect',
  [FeatureName.CA3000CardClasses]: 'Card Access Classes (Access Groups)',
  [FeatureName.CA3000Expirations]: 'Credential Expirations',
  [FeatureName.NorthStar]: 'EIQ-NorthSync',
  [FeatureName.ConnectEditPin]: 'Edit Pin',
  [FeatureName.CA3KLogsImport]: 'Event Logs',
  [FeatureName.CreateResidentAnonymously]: 'Anonymous Resident Creation',
  [FeatureName.MassAlerts]: 'EIQ-Alert',
  [FeatureName.IncidentReporter]: 'EIQ-Reporter',
  [FeatureName.LPR]: 'EIQ-PlateScan',
  [FeatureName.EIQWhoIs]: 'EIQ-WhoIs',
  [FeatureName.GuestLimitations]: 'Guest Limitations',
  [FeatureName.GuestLimitationsForAdmins]: 'Restrict EIQ-Manage Option',
  [FeatureName.DriveId]: 'Drive Id',
  [FeatureName.BasIP]: 'EIQ-Welcome',
  [FeatureName.SmartPlateId]: 'SmartPlateID',
  [FeatureName.Jonas]: 'EIQ-JonasSync',
  [FeatureName.GateController]: 'Gate Controller',
  [FeatureName.EIQLive]: 'EIQ-Live (Live Activity)',
  [FeatureName.DailyActivityReports]: 'Daily Activity Reports',
  [FeatureName.EIQProfile]: 'EIQ-Profile',
  [FeatureName.PayEase]: 'EIQ-PayEase',
  [FeatureName.EIQIntelliTicketEscalationTiers]: 'EIQ-IntelliTicket Escalation Tiers',
  [FeatureName.ConnectFID]: 'EIQ-Connect FID',
};
